/**
 * Hovercontext runtime settings. Marker colour is NOT user-configurable —
 * it's mode-driven (see `Marker.tsx`). Per the Agentation spec the
 * settings panel surfaces: output detail, React component visibility,
 * page-interaction blocking, auto-send, layout-mode enablement, MCP
 * base URL, and the webhooks list.
 */
export const DEFAULT_SETTINGS = {
    outputDetail: "standard",
    componentDetail: "standard",
    blockInteraction: true,
    showReactComponents: true,
    autoSend: false,
    layoutModeEnabled: false,
    captureScreenshots: false,
    captureOuterHTML: false,
    webhooks: [],
    mcpBaseUrl: "http://127.0.0.1:4747",
};
//# sourceMappingURL=settings.js.map